import { useEffect, useState } from "react";
import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import Image from "next/image";
import Rating from "@/components/BreedPage/Rating";
interface Props {
  data: any;
  hasReview: Boolean;
}

export default function Characteristics({ data, hasReview }: Props) {
  const [sizeBreed, setSizeBreed] = useState<String>("");

  useEffect(() => {
    setSizeBreed(data.attributes.size);
  }, [data])

  return (
    <Box
      as="section"
      flexDirection={{ base: "column", lg: "row" }}
      width="100%"
      paddingBottom={{ base: "0", lg: "80px" }}
      paddingTop="0"
    >
      <Flex
        direction={{ base: "column", lg: "row" }}
        maxWidth="1216px"
        width="90%"
        margin="0 auto"
        p={{ base: "24px 0 24px 0", lg: "0" }}
        gap={{ base: "16px", lg: "32px" }}
      >
        <Flex
          p={{ base: "16px", lg: "32px" }}
          direction="column"
          gap={{ base: "16px", lg: "32px" }}
          bgColor="#FFF"
          boxShadow="0px 1px 2px 0px rgba(0, 0, 0, 0.06), 0px 1px 3px 0px rgba(0, 0, 0, 0.10)"
          borderRadius="16px"
          flex="1 0 0"
        >
          {/* BEHAVIORS */}
          <Flex gap="16px" flexWrap="wrap">
            {data.attributes.behaviors.data.map((item: any, index: number) => (
              <Box key={index} p="12px 16px" bgColor="gray.50" borderRadius="54px">
                <Text
                  fontSize="12px"
                  lineHeight="16px"
                  fontWeight="500"
                  textTransform="uppercase"
                  color="gray.600"
                >
                  {item.attributes.name}
                </Text>
              </Box>
            ))}
          </Flex>
          {/* CHARACTERISTICS */}
          <Flex direction="column" pt="16px" gap="24px">
            <Heading
              as="h3"
              fontSize={{ base: "24px", lg: "36px" }}
              lineHeight={{ base: "32px", lg: "40px" }}
              fontWeight="700"
              color="gray.800"
            >
              Características
            </Heading>
            <Text
              as="p"
              fontSize={{ base: "16px", lg: "18px" }}
              lineHeight={{ base: "24px", lg: "28px" }}
              color="gray.600"
            >
              {data.attributes.characteristic}
            </Text>
          </Flex>
          <Flex gap="32px" direction={{ base: "column", lg: "row" }}>
            {/* WEIGHT */}
            <Flex direction="column" p={{ base: "16px", lg: "32px" }} gap="32px" border="1px solid #E2E8F0" borderRadius="16px" alignItems={{ base: "center", lg: "flex-start" }} justifyContent="space-between">
              <Text
                fontSize="18px"
                lineHeight="28px"
                fontWeight="700"
                color="gray.700"
              >
                Peso
              </Text>
              <Flex direction="column" gap="16px" alignItems="center">
                <Image
                  src='/images/characteristics/weight.svg'
                  alt='weight'
                  width={103}
                  height={102}
                />
                <Text
                  fontSize="16px"
                  lineHeight="28px"
                  fontWeight="700"
                  color="gray.500"
                >
                  {data.attributes.minWeight}kg a {data.attributes.maxWeight}kg
                </Text>
              </Flex>
            </Flex>
            {/* HEIGHT */}
            <Flex direction="column" p={{ base: "16px", lg: "32px" }} border="1px solid #E2E8F0" borderRadius="16px" w="100%" alignItems={{ base: "center", lg: "normal" }}>
              <Text
                fontSize="18px"
                lineHeight="28px"
                fontWeight="700"
                color="gray.700"
              >
                Altura
              </Text>
              <Flex justifyContent="space-between" alignItems="center">
                <Flex direction="column" gap="24px" alignItems="center" justifyContent="flex-end" height="100%">
                  <Image
                    src='/images/characteristics/dogHeight1.svg'
                    alt='height'
                    width={132}
                    height={67}
                    style={{ filter: sizeBreed === 'pequeno' ? 'none' : 'brightness(1.4) grayscale(1)' }}
                  />
                  <Text
                    fontSize={{ base: "16px", lg: "18px" }}
                    lineHeight={{ base: "22px", lg: "28px" }}
                    fontWeight="700"
                    color={sizeBreed === 'pequeno' ? "gray.600" : "gray.400"}
                    textAlign="center"
                  >
                    Pequeno porte
                  </Text>

                </Flex>
                <Flex direction="column" gap="24px" alignItems="center" justifyContent="flex-end" height="100%" >
                  <Image
                    src='/images/characteristics/dogHeight2.svg'
                    alt='height'
                    width={135}
                    height={92}
                    style={{ filter: sizeBreed === 'médio' ? 'none' : 'brightness(1.4) grayscale(1)' }}
                  />
                  <Text
                    fontSize={{ base: "16px", lg: "18px" }}
                    lineHeight={{ base: "22px", lg: "28px" }}
                    fontWeight="700"
                    color={sizeBreed === 'médio' ? "gray.600" : "gray.400"}
                    textAlign="center"
                  >
                    Médio porte
                  </Text>
                </Flex>
                <Flex direction="column" gap="24px" alignItems="center" justifyContent="flex-end" height="100%">
                  <Image
                    src='/images/characteristics/dogHeight3.svg'
                    alt='height'
                    width={143}
                    height={131}
                    style={{ filter: sizeBreed === 'grande' ? 'none' : 'brightness(1.4) grayscale(1)' }}
                  />
                  <Text
                    fontSize={{ base: "16px", lg: "18px" }}
                    lineHeight={{ base: "22px", lg: "28px" }}
                    fontWeight="700"
                    color={sizeBreed === 'grande' ? "gray.600" : "gray.400"}
                    textAlign="center"
                  >
                    Grande porte
                  </Text>
                </Flex>

              </Flex>


            </Flex>
          </Flex>
          <Flex p={{ base: "16px", lg: "32px" }} border="1px solid #E2E8F0" borderRadius="16px">

            <Flex
              alignItems="center" justifyContent="space-between"
              width="100%"
              direction={{ base: "column", lg: "row" }}
              gap={{ base: "40px", lg: "0px" }}
            >
              {/* LIFE EXPECTANCY */}
              <Flex gap="32px">
                <Flex
                  width="88px" height="88px" padding="10px" alignItems="center" justifyContent="center"
                  borderRadius="50px" bgColor="purple.50"
                >
                  <Image
                    src='/images/characteristics/iconHeart.svg'
                    alt='heart'
                    width={40}
                    height={40}
                  />
                </Flex>
                <Flex direction="column" gap="12px">
                  <Text
                    fontSize={{ base: "16px", lg: "18px" }}
                    lineHeight={{ base: "24px", lg: "28px" }}
                    color="gray.700"
                    whiteSpace="pre-line"
                  >
                    {"Espectativa \nde vida"}
                  </Text>
                  <Text
                    fontSize="36px"
                    lineHeight="40px"
                    fontWeight="700"
                    color="purple.600"
                  >
                    {data.attributes.lifeExpectancyInYears} anos
                  </Text>
                </Flex>
              </Flex>
              <Box
                display={{ base: "none", lg: "block" }}
                width="1px"
                height="93px"
                bgColor="#E2E8F0"
              />
              {/* MANDATORY VACCINES */}
              <Flex gap="32px">
                <Flex
                  width="88px" height="88px" padding="10px" alignItems="center" justifyContent="center"
                  borderRadius="50px" bgColor="purple.50"
                >
                  <Image
                    src='/images/characteristics/iconSyringe.svg'
                    alt='heart'
                    width={40}
                    height={40}
                  />
                </Flex>
                <Flex direction="column" gap="12px">
                  <Text
                    fontSize={{ base: "16px", lg: "18px" }}
                    lineHeight={{ base: "24px", lg: "28px" }}
                    color="gray.700"
                    whiteSpace="pre-line"
                  >
                    {"Vacinações básicas \nobrigatórias"}
                  </Text>
                  <Text
                    fontSize="36px"
                    lineHeight="40px"
                    fontWeight="700"
                    color="purple.600"
                  >
                    {data.attributes.mandatoryVaccines ? data.attributes.mandatoryVaccines : '11'}
                  </Text>
                </Flex>
              </Flex>

            </Flex>
          </Flex>

        </Flex>
        <Rating ratingData={data.attributes.rating} hasReview={hasReview} />
      </Flex>
    </Box>
  )
}
